module.exports = __webpack_public_path__ + "static/media/TalkedToFive.b82cc82c.png";